import React from "react";
import { cn } from "@/lib/utils";
import Link from "next/link";

interface FancyButtonProps {
  onClick?: () => void;
  href?: string;
  inNewTab?: boolean;
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

const FancyButton: React.FC<FancyButtonProps> = ({
  onClick,
  href,
  inNewTab = false,
  children,
  disabled = false,
  className,
  size = "md",
}) => {
  const sizeClasses = {
    sm: "px-2.5 py-1.5 text-xs",
    md: "px-3.5 py-2 text-sm",
    lg: "px-4 py-2.5 text-base",
    xl: "px-5 py-3 text-lg",
  };

  const sharedClassName = cn(
    "font-normal crayo-fancy-btn transition-all duration-300",
    sizeClasses[size],
    disabled ? "cursor-not-allowed opacity-50 hover:opacity-50" : "cursor-pointer hover:opacity-90",
    className,
  );

  if (href) {
    return (
      <Link
        href={href}
        className={sharedClassName}
        target={inNewTab ? "_blank" : undefined}
        rel={inNewTab ? "noopener noreferrer" : undefined}
      >
        {children}
      </Link>
    );
  }

  return (
    <button className={sharedClassName} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export default FancyButton;
